import React, { useState, useEffect, useContext, Fragment } from 'react';
import { useParams } from "wouter";
import { Popover } from '@headlessui/react';
import { listOrganizationalUnits, getOrganizationalUnit, updateOrganizationalUnit } from '../services/api_org_unit';
import { AuthContext } from '../contexts/auth';
import { Link } from 'wouter';
import Footer from '../components/footer';
import ComboboxAutocomplete from '../components/combobox_autocomplete';
import { MessageContext } from '../contexts/message';
import { useLocation } from 'wouter';
import Swal from 'sweetalert2';
import PopoverComponentCustom from '../components/popover_component';
import { v2EstraiMessaggiErrore } from '../services/utils';


const OrgEdit = () => {
    const { ou_id } = useParams();
    const [units, setUnits] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [unitData, setUnitData] = useState({});
    const [editedName, setEditedName] = useState('');
    const { profile, token, setProfile } = useContext(AuthContext);
    const [parentId, setParentId] = useState(null);
    const message = useContext(MessageContext);
    const [location, setLocation] = useLocation();
    const [isSaving, setIsSaving] = useState(false);
    const [permissions, setPermissions] = useState([]);


    useEffect(() => {
        setIsLoading(true);
        setIsError(false);
        
        if(ou_id) {
            listOrganizationalUnits(token, true, ou_id).then((data) => {
                const unitsData = data.data;
                setUnits(unitsData);

                getOrganizationalUnit(token, ou_id).then((data) => {
                    const selectedUnit = data.data;
                    if(selectedUnit) {
                        const selectedUnitParent = unitsData.find((unit) => unit.id == selectedUnit.parent);
                        if(selectedUnitParent) {
                            setParentId({
                                name: selectedUnitParent.name,
                                id: selectedUnitParent.id,
                            })
                        }
    
                        setUnitData(selectedUnit);
                        setEditedName(selectedUnit.name);
                    }
                }).catch(error => {
                    console.error('Error fetching units:', error);
                    setIsError(true);
                });
                
            }).catch(error => {
                console.error('Error fetching units:', error);
                setIsError(true);
            }).finally(() => {
                setIsLoading(false);
            });
        }
        
    }, [ou_id]);

    const handleParentChange = (selectedParent) => {
        if (selectedParent !== undefined) {
            setParentId(selectedParent);

        } else {
            setParentId(null);

        }
    };


    const handleSave = async () => {
        setIsSaving(true);
        try {
            if (ou_id) {
                await updateOrganizationalUnit(token, ou_id, { name: editedName, parent: parentId?.id });
                Swal.fire({
                    position: "center",
                    title: "Salvato!",
                    text: 'Unità Organizzativa aggiornata con successo!',
                    showConfirmButton: false,
                    icon: 'success',
                    timer: 2000,
                });
                const updatedUnits = await listOrganizationalUnits(token);
                setUnits(updatedUnits.data);
                setLocation(`/organization/${ou_id}`);               
            } else {
                console.error('Error: ou_id is undefined');
            }
        } catch (error) {
            console.error('Error updating organizational unit:', error);

            const errorMessage = v2EstraiMessaggiErrore(error);

            Swal.fire({
                title: 'Errore',
                text: errorMessage,
                icon: 'error',
            });
        } finally {
            setIsSaving(false);
        }
    }; 

    // const filteredUnits = units.filter((unit: any) => {
    //     return unit.name.toLowerCase().includes(query.toLowerCase());
    // });

    if(isLoading)
        return <div className="relative block w-full rounded-lg  p-12 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2">
            <div role="status">
                <svg className="inline w-10 h-10 mr-2 text-gray-200 animate-spin dark:text-grey-100 fill-indigo-500" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                </svg>
                <span className="sr-only">Loading...</span>
            </div>
            <span className="mt-2 block text-sm font-semibold text-gray-900">Caricamento...</span>
        </div>

    if (isError) return <div>Error loading data</div>;

    return (
        <div className="flex flex-col min-h-screen">
            <PopoverComponentCustom title='Modifica Unità Organizzativa' />

            <main className="mt-10 pb-8 px-5 flex-grow">
                <div className='container mx-auto px-5 m-5'>
                    <div>
                        <button>
                            <Link to={`/organization/${ou_id}`} className="border block rounded-md bg-grey-400 px-3 py-2 mr-2 text-center text-sm font-semibold text-grey-800 shadow-sm hover:bg-grey-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-grey-600 hover:bg-gray-100">Torna indietro</Link>
                        </button>
                    </div>
                    <div className='border border-gray-200 rounded-md shadow-md my-4'>
                        <div className='p-5'>
                            <p className='text-sm font-semibold uppercase flex items-center justify-items-center pl-2'>Nome</p>
                            <input 
                                type="text" 
                                className='border-gray-200 shadow-md rounded-md mt-2 w-full text-gray-500 hover:border-indigo-500 focus:border-indigo-100 outline-none'
                                value={editedName}
                                onChange={(e) => setEditedName(e.target.value)}
                            />
                        </div>
                        <div className='p-5'>                            
                            <p className='text-sm font-semibold uppercase flex items-center justify-items-center pl-2'>Unità di appartenenza: </p>
                            <ComboboxAutocomplete
                                options={[
                                    { id: null, name: 'Nessuna unità' },
                                    ...units.filter((unit) => unit.id !== unitData.id)
                                ]} 
                                bgActiveColor="bg-indigo-100"
                                textActiveColor="text-gray-900" 
                                placeholder='Seleziona Unità'
                                onChange={handleParentChange}
                                value={parentId}
                                borderClass='border-gray-200 rounded-lg shadow-md'
                            />
                
                        </div>
                        <div className='justify-center flex mb-4'>
                            <button 
                                className={`border block rounded-md px-3 py-2 mr-2 text-center text-sm font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 w-32 ${
                                    isSaving ? 'bg-gray-400 cursor-not-allowed' : 'bg-indigo-500 hover:bg-indigo-600 focus-visible:outline-indigo-600'
                                }`}
                                onClick={handleSave}
                                disabled={isSaving}
                            > 
                                {isSaving ? 'Salvataggio...' : 'SALVA'}
                            </button>
                        </div>
                    </div>
                </div>


            </main>
            <Footer />
        </div>
    );
};

export { OrgEdit };
